
var ProductMetaData = (function () {
  const url = "https://codeage-shopify-api.herokuapp.com";

  //const url = "https://fbe0-112-207-188-198.ngrok-free.app";

  return {
    get: function (id, cb, errCb) {
      $.ajax({
        type: "GET",
        url: url + "/api/product/metadata",
        data: {
          id: id,
        },
        success: function (data) {
          cb(data);
        },
        error: function (err) {
          errCb(err);
        },
      });
      return;
    },

    getAssociatedSurveys: function (id, cb, errCb) {
      $.ajax({
        type: "GET",
        url: url + "/api/product/" + id + "/surveys",
        success: function (data) {
          cb(data);
        },
        error: function (err) {
          errCb(err);
        },
      });
      return;
    },

    getQMCTally: function (surveyId, cb, errCb) {
      $.ajax({
        type: "GET",
        async: false,
        url: url + "/api/product/survey",
        data: {
          id: surveyId,
        },
        success: function (data) {
          cb(data);
        },
        error: function (err) {
          errCb(err);
        },
      });
      return;
    },
    postQMC: function (data, cb, errCb, completeCb) {
      $.ajax({
        type: "POST",
        url: url + "/api/product/survey",
        data: data,
        success: function (data) {
          cb(data);
        },
        error: function (err) {
          console.log("error:", err);
          errCb(err);
        },
        complete: function () {
          if (completeCb instanceof Function) {
            completeCb();
          }
        },
      });
      return;
    },

    processImageSrc: function (src) {
      const prefix =
        "https://bucketeer-a36b7e66-cbac-4118-9999-c7b52a2bd914.s3.amazonaws.com/";
      return prefix + src;
    }
    
  };
})();